export default function () {
  return {
    routeNameSteps: {
      STARTED: 'start-teaching',
      PERSONAL_INFO: 'start-teaching-steps-personal-info',
      LANGUAGES: 'start-teaching-steps-languages',
      TEACHING_COURSES: 'start-teaching-steps-teaching-courses',
      TEACHING_PRICE: 'start-teaching-steps-teaching-price',
      EDUCATION_DEGREES: 'start-teaching-steps-education-degrees',
      WORK_EXPERIENCES: 'start-teaching-steps-work-experiences',
      CERTIFICATES: 'start-teaching-steps-certificates',
      PROFILE_PICTURE: 'start-teaching-steps-profile-picture',
      TEACHER_ABOUT: 'start-teaching-steps-teacher-about',
      INTRO_VIDEO: 'start-teaching-steps-intro-video',
      WORKTIMES: 'start-teaching-steps-worktimes',
      DOCUMENTS: 'start-teaching-steps-documents',
      TRACKING: 'start-teaching-steps-tracking'
    },
    stepStatus: null,
    personalInfoFetchedData: {},
    personalInfo: {
      first_name: '',
      last_name: '',
      gender: 'male',
      birthdate: '',
      born_zn_country_id: '',
      live_zn_country_id: '',
      mobile_zn_country_id: '',
      mobile_number: '',
      language: []
    },
    languages: {},
    teachingCourses: [],
    teachingPriceFetchedData: {},
    educationDegrees: {},
    workExperiences: {},
    certificates: {},
    profilePicture: {},
    teacherAbout: {},
    introVideo: {},
    workTime: {},
    documents: {},
    tracking: {},
    priceChart: {},
    tagline: {},
    introduction: {},
    join_us: {}
  }
}
